import Swiper from 'swiper/dist/js/swiper.min';

export default class Facing {
  constructor(parent) {
    this.parent = parent;
    const self = this;
    const facing = parent;
    this.mainSlider = {
      options: {
        slidesPerView: 1,
        spaceBetween: 20,
        resistance: true,
        resistanceRatio: 0,
        preloadImages: false,
        lazy: {
          loadPrevNext: false,
        },
        loop: true,
        navigation: {
          disabledClass: 'sliderButtons__btn--disabled',
        },
        on: {
          init() {
            this.params.navigation.prevEl = this.el.querySelector('.sliderButtons__btn--prev');
            this.params.navigation.nextEl = this.el.querySelector('.sliderButtons__btn--next');
          },
          slideChange() {
            const thumbSlides = [].slice.call(self.thumbSlider.instance.slides);
            thumbSlides.forEach(slide => slide.classList.remove('facing__thumb-slide--active'));
            thumbSlides[this.realIndex].classList.add('facing__thumb-slide--active');
            self.thumbSlider.instance.slideTo(this.realIndex);
          },
        },
      },
      instance: null,
    };
    this.thumbSlider = {
      options: {
        resistance: true,
        resistanceRatio: 0,
        freeMode: true,
        slidesPerView: 'auto',
        spaceBetween: 14,
        on: {
          init() {
            const slides = [].slice.call(this.slides);

            slides.forEach((slide, index) => {
              slide.classList.remove('facing__thumb-slide--active');

              slide.addEventListener('click', () => {
                self.mainSlider.instance.slideToLoop(index);
              });
            });
            slides[0].classList.add('facing__thumb-slide--active');
          },
        },
        breakpoints: {
          767: {
            spaceBetween: 7,
          },
        },
      },
      instance: null,
    };

    if (facing) {
      this.tabBtns = [].slice.call(facing.querySelectorAll('.facing__tab-btn'));
      this.sliders = [].slice.call(facing.querySelectorAll('.facing__tab'));

      if (this.tabBtns.length !== 0) {
        this.tabBtns.forEach((btn, index) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();

            this.changeTabs(btn, index);
            this.initSliders(this.sliders[index]);
          });
        });
      }

      if (this.sliders.length !== 0) {
        this.initSliders(this.sliders[0]);
      }
    }
  }

  changeTabs(btn, index) {
    this.tabBtns.forEach(tmp => tmp.classList.remove('facing__tab-btn--active'));
    this.sliders.forEach(tmp => tmp.classList.remove('facing__tab--active'));

    if (this.thumbSlider.instance !== null) {
      this.thumbSlider.instance.destroy(true, true);
      this.mainSlider.instance.destroy(true, true);
      this.thumbSlider.instance = null;
      this.mainSlider.instance = null;
    }

    btn.classList.add('facing__tab-btn--active');
    this.sliders[index].classList.add('facing__tab--active');
  }

  initSliders(slidersWrp) {
    const mainSlider = slidersWrp.querySelector('.facing__main-slider');
    const thumbSlider = slidersWrp.querySelector('.facing__thumb-slider');
    const sliderBtnsWrp = slidersWrp.querySelector('.facing__slider-btns');
    const slides = [].slice.call(mainSlider.querySelectorAll('.facing__main-slide'));

    if (this.thumbSlider.instance === null) {
      if (slides.length > 1) {
        this.thumbSlider.instance = new Swiper(thumbSlider, this.thumbSlider.options);
        this.mainSlider.instance = new Swiper(mainSlider, this.mainSlider.options);
      } else {
        sliderBtnsWrp.style.display = 'none';
        thumbSlider.style.display = 'none';
      }
    }
  }
}



// WEBPACK FOOTER //
// ./blocks/facing/facing.js